import styled from 'styled-components';

export const Level2 = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  overflow: auto;
`;

export const SectionTitle = styled.h1`
  font-size: 16px;
  font-weight: 300;
  line-height: 72px;
  color: #8c8c8c;
  margin-top: -16px;
`;

export const SectionNodes = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-right: -16px;
`;

export const Section = styled.div`
  &:first-child {
    ${SectionTitle} {
      margin-top: 0;
    }
  }
`;

export const Sections = styled.div`
  flex: 1;
  position: relative;
  padding: 0 16px;
  overflow: auto;
`;
